package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import org.example.project.settings.LumaticaCheckbox
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun LinkedInDmProfileEditor(checks: List<All>, onChange: (List<All>) -> Unit, minimal: Boolean = false) {
    var preview by remember { mutableStateOf<Set<String>>(emptySet()) }
    Div({ style { height(100.percent); minHeight(0.px); overflowY("auto") } }) {
        Div({ style { padding(18.px); overflowY("auto") } }) {
            if (!minimal) Div({ style { textAlign("center"); fontWeight("700"); marginBottom(14.px) } }) { Text("Checkboxen") }
            checks.sortedBy { it.linkedinDmCheckboxPrio }.forEach { row ->
                val id = row.linkedinDmCheckboxId
                Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px); marginBottom(10.px) } }) {
                    LumaticaCheckbox(checked = id in preview, onChange = { preview = if (it) preview + id else preview - id })
                    EditorInput(row.linkedinDmCheckboxText, "Checkbox-Name", { text -> onChange(checks.map { if (it.linkedinDmCheckboxId == id) it.copy(linkedinDmCheckboxText = text) else it }) }, grow = true)
                    EditorClose("Checkbox entfernen", { onChange(checks.filterNot { it.linkedinDmCheckboxId == id }) })
                }
            }
            EditorAdd("Checkbox hinzufügen", {
                val id = js("crypto.randomUUID()") as String
                onChange(checks + All(linkedinDmCheckboxId = id, linkedinDmCheckboxText = "Neue Checkbox", linkedinDmCheckboxAktiv = true,
                    linkedinDmCheckboxPrio = (checks.maxOfOrNull { it.linkedinDmCheckboxPrio } ?: 0) + 10))
            })
        }
    }
}
